import { Spin } from "antd";

import styleModule from "./SpinnerPage.module.css";

import { LoadingOutlined } from "@ant-design/icons";

const antIcon = (
  <LoadingOutlined width={64} height={64} style={{ fontSize: 64 }} spin />
);

export function SpinnerPage({ style }: { style?: React.CSSProperties }) {
  return (
    <Spin className={styleModule.spinner} style={style} indicator={antIcon} />
  );
}
